// Import GC Providers
import AuthProvider from './AuthContext';           // AuthProvider (Skybase, NOT @Clerk)
import DataProvider from './DataContext';           // DataProvider
import QueryProvider from './QueryContext';         // QueryProvider
import BillingProvider from './BillingContext';     // BillingProvider



// ============
// AppProviders – provides all React Components with necessary GC
// ============
export default function AppProviders({ children }) {
    
    // JSX Component
    return(
        <AuthProvider>
            <DataProvider>
                <BillingProvider>
                    <QueryProvider>
                        { children }
                    </QueryProvider>
                </BillingProvider>
            </DataProvider>
        </AuthProvider>
    );
}